"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _FolderItemStyled = require("./FolderItem-styled.js");
var _FolderOpenIcon = _interopRequireDefault(require("calcite-ui-icons-react/FolderOpenIcon"));
var _FolderIcon = _interopRequireDefault(require("calcite-ui-icons-react/FolderIcon"));
var _HomeIcon = _interopRequireDefault(require("calcite-ui-icons-react/HomeIcon"));
var _stateTypes = _interopRequireDefault(require("../../store/stateTypes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var FolderItem = function FolderItem(_ref) {
  var _ref$item = _ref.item,
    id = _ref$item.id,
    title = _ref$item.title,
    state = _ref$item.state,
    selectedFolderId = _ref.selectedFolderId,
    onFolderItemClick = _ref.onFolderItemClick;
  var active = state === _stateTypes.default.FOLDER_ITEM_ACTIVE || selectedFolderId === id;
  var disabled = state === _stateTypes.default.FOLDER_ITEM_DISABLED;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FolderItemStyled.StyledFolderItem, {
    active: active,
    disabled: disabled,
    leftNode: id === "root" ? /*#__PURE__*/_react.default.createElement(_HomeIcon.default, {
      size: 16
    }) : active ? /*#__PURE__*/_react.default.createElement(_FolderOpenIcon.default, {
      size: 16
    }) : /*#__PURE__*/_react.default.createElement(_FolderIcon.default, {
      size: 16
    }),
    onClick: function onClick() {
      return onFolderItemClick(id);
    }
  }, /*#__PURE__*/_react.default.createElement(_FolderItemStyled.StyledListItemTitle, {
    active: active
  }, title)));
};
var _default = FolderItem;
exports.default = _default;